/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cc_aaa_normal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAA normal text`)
};

const es_cc_aaa_normal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAA texto normal`)
};

const de_cc_aaa_normal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAA normaler Text`)
};

const nl_cc_aaa_normal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAA normale tekst`)
};

const fr_cc_aaa_normal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAA texte normal`)
};

const it_cc_aaa_normal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAA testo normale`)
};

const pt_br2_cc_aaa_normal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAA texto normal`)
};

const pt_cc_aaa_normal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAA texto normal`)
};

const ja_cc_aaa_normal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAA 通常テキスト`)
};

const zh_cc_aaa_normal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAA 级 · 正文文字`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cc_aaa_normal = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cc_aaa_normal(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cc_aaa_normal", locale)
	if (locale === "en") return en_cc_aaa_normal(inputs)
	if (locale === "es") return es_cc_aaa_normal(inputs)
	if (locale === "de") return de_cc_aaa_normal(inputs)
	if (locale === "nl") return nl_cc_aaa_normal(inputs)
	if (locale === "fr") return fr_cc_aaa_normal(inputs)
	if (locale === "it") return it_cc_aaa_normal(inputs)
	if (locale === "pt-BR") return pt_br2_cc_aaa_normal(inputs)
	if (locale === "pt") return pt_cc_aaa_normal(inputs)
	if (locale === "ja") return ja_cc_aaa_normal(inputs)
	return zh_cc_aaa_normal(inputs)
};